import { FC, Fragment, useState } from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import {
  DropdownArrPropsType,
  IconIdType,
  MultiDropType
} from "DataTypes/Form";
import { CommonStyle } from "Components";
import InputLabel from "Components/ControlledForm/Input/Label";
import { useSelector } from "react-redux";
import ImgPath from "Constant/Imgs";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const MultiApi1: FC<MultiDropType> = (props) => {
  const {
    id,
    label,
    placeholder,
    error,
    errorText,
    required,
    readOnly,
    dropArr,
    inputChange,
    dropVal,
    onClick,
    loading,
    inputVal,
    enableFormLoad,
    iconSearch,
    onIconClick,
  } = props;
  const newDropVal = dropVal || [];
  const newDropArr = dropArr || [];
  const newInputVal = (
    iconSearch ?
      inputVal :
      newDropArr
        .filter(el => newDropVal.includes(el.value))
        .map((el) => el.label).toString()
  ) || "";
  const formLoad = useSelector((state: any) => state?.screen?.formLoad);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [localLoad, setLocalLoad] = useState(false);
  const [searchedVal, setSearchedVal] = useState("");
  const viewOnly = readOnly || (enableFormLoad ? formLoad : false);
  const loadingOnly =
    loading ||
    localLoad ||
    (enableFormLoad ? formLoad : false);

  const handleIconClick = async (iconId: IconIdType): Promise<void> => {
    setLocalLoad(true);
    const newSearchedVal = iconId == "clear" ? "" : newInputVal.toLowerCase();
    if (onIconClick && newSearchedVal !== searchedVal) {
      await onIconClick(iconId);
      setSearchedVal(newSearchedVal);
    }
    setLocalLoad(false);
  };

  return (
    <Fragment>
      {label && (
        <InputLabel label={label} required={required ? required : false} />
      )}
      <Autocomplete
        id={"multiple-limit-tags" + id}
        multiple
        readOnly={readOnly || false}
        options={dropArr || []}
        inputValue={newInputVal}
        clearIcon={null}
        onInputChange={(event, val, reason) => {
          if (reason !== "reset" && iconSearch && inputChange) {
            inputChange(val)
          }
        }}
        filterOptions={(option) => option}
        loading={loadingOnly}
        disabled={viewOnly}
        {...(iconSearch ?
          {
            onKeyDown: (event) => {
              if (event.key === "Enter") handleIconClick("search");
            }
          }
          : {}
        )}
        renderOption={(props, option: DropdownArrPropsType) => {
          return (
            <Box
              key={option.id}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
              }}
              className="test"
            >
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={newDropVal.includes(option.value)}
                onClick={(event) => {
                  const target = event.target as HTMLInputElement;
                  if (target.checked) {
                    onClick && onClick([...newDropVal, option.id]);
                  } else {
                    onClick && onClick(
                      newDropVal.filter((id) => id !== option.id)
                    );
                  }
                }}
                disabled={readOnly}
              />
              <Typography variant="subtitle1">{option.label}</Typography>
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            placeholder={placeholder}
            error={error}
            {...params}
            sx={{
              ...(readOnly ? { ...sxReadOnly } : { ...CommonStyle.sxWhiteBox }),
              "&>div": {
                p: "0px !important",
                fontSize: "0.85rem",
                "& >div": {
                  right: "0px !important",
                  position: "unset",
                },
                "& >input": {
                  px: 0.5,
                  py: 1,
                },
                "& >fieldset": {
                  borderWidth: 0,
                },
              },
            }}
            InputProps={{
              ...params.InputProps,
              ...({
                endAdornment: (
                  <>
                    {(iconSearch && newInputVal) ?
                      <IconButton
                        title="Clear"
                        sx={{ ...sxInputIcon }}
                        onClick={() => handleIconClick("clear")}
                      >
                        <ImgPath.CloseIcon color="primary" />
                      </IconButton>
                      : <></>
                    }
                    {(iconSearch) ?
                      <IconButton
                        title="Search"
                        sx={{ ...sxInputIcon }}
                        onClick={() => handleIconClick("search")}
                      >
                        <ImgPath.SearchIcon color="primary" />
                      </IconButton>
                      : <></>
                    }
                    {params.InputProps.endAdornment}
                  </>
                )
              })
            }}
          />
        )}
      />
      {error && (
        <Typography variant="subtitle2" color="red">
          {errorText}
        </Typography>
      )}
    </Fragment>
  );
};
export default MultiApi1;

const sxReadOnly = {
  backgroundColor: "custom.grey",
  boxShadow: "0px 0px 6px #00000029",
  borderRadius: 1.25,
  " >fieldset": {
    display: "none",
  },
};

const sxInputIcon = {
  p: 0.35,
  "&>svg": {
    width: "0.9em", height: "0.9em"
  }
}

//=> There will be 2 types of multi select dropdown:

//=> Normal multi select where
///=> Input field will be readonly.
///=> Filter will not work.
///=> Input value will be the result of comma seperated selected options label.
///=> Clear Icon and search not available.

//=> Api multi select where
///=> Filter will work on api call.
///=> User can only select values from api filtered options.
///=> Filter options changes will not impact the selected options.
///=> Clear Icon will clear input search and all selected options.
///=> Search Icon will filter new options.
